// All customers related apis
import { API_URL } from "./api";
import instance from "./api";
import { encryptData } from "../helpers/encryptDecrypt";

// Get api for fetching the customer's details with phone number
export const fetchCustomers = async (phoneNumber, selectedOrganization) => {
  return await instance.get(API_URL + "/customers", {
    params: {
      phone_number: phoneNumber,
      selectedOrganization: selectedOrganization,
    },
  });
};

// Post api for creating new customer for the active organization
export const addCustomer = async (customerData) => {
  return await instance.post(API_URL + "/customers", customerData);
};

// Post api for creating customers in bulk for the active organization
export const addBulkCustomers = async (customerData) => {
  return await instance.post(API_URL + "/bulk-create/customers", customerData);
};

// Post api for updating the existing customer's details
export const editCustomer = async (customerData, id) => {
  const cId = encryptData(id);
  return await instance.post(`${API_URL}/customers/${cId}`, customerData);
};

// Delete api for deleting the existing customer
export const deleteCustomer = async (id) => {
  const cId = encryptData(id);
  return await instance.delete(`${API_URL}/customers/${cId}`);
};

// Post api for deleting the existing customers in bulk
export const deleteMultipleCustomers = async (data) => {
  return await instance.post(`${API_URL}/delete-multiple-customers`, data);
};

// Get api for fetching customers for the active organization with the filtering of search keyword
export const fetchCustomersByOrganization = async (
  organizationId,
  keyword,
  page,
  limit
) => {
  const oId = encryptData(organizationId);
  return await instance.get(
    `${API_URL}/organizations/${oId}/customers?keyword=${keyword}&page=${page}&limit=${limit}`
  );
};

// Get api for fetching the customer's purchases/sales data
export const fetchPurchasesByCustomer = async (customerId) => {
  const cId = encryptData(customerId);
  return await instance.get(`${API_URL}/customers/${cId}/purchases`);
};

// Get api for fetching the customer's orders data
export const fetchOrdersByCustomer = async (customerId) => {
  const cId = encryptData(customerId);
  return await instance.get(`${API_URL}/customers/${cId}/orders`);
};

// Post api for adding credit balance to the customer's account (this is also used for reducing the credit balance by providing negative amount)
export const addCustomerBalance = async (customerId, data) => {
  const cId = encryptData(customerId);
  return await instance.post(`${API_URL}/customers/${cId}/balance`, data);
};

// Get api for fetching customer's credit activities
export const fetchCreditActivitiesByCustomer = async (customerId) => {
  const cId = encryptData(customerId);
  return await instance.get(`${API_URL}/customers/${cId}/credit-activities`);
};
